<template>
  <div class="c-led-canvas" @click="$emit('click')">
    <canvas ref="canvas" :width="width" :height="height" />
  </div>
</template>
<script>
export default {
  name: "CLedCanvas",
  props: {
    frames: Array,
    speed: Number,
  },
  data() {
    return {
      canvasContext: null,
      width: 1605,
      height: 205,
      index: 0,
      timer: null,
    };
  },
  methods: {
    play() {
      this.index = 0;
      clearTimeout(this.timer);
      this.canvasContext.clearRect(0, 0, this.width, this.height);
      let speed = this.speed;
      speed = speed > 100 ? 100 : speed;
      if (this.frames.length === 1) {
        this.drawFrame();
      } else if (this.frames.length > 1) {
        this.timer = setInterval(() => {
          this.index = this.index + 1;
          if (this.index >= this.frames.length) this.index = 0;
          this.drawFrame();
        }, speed - 2);
      }
    },
    drawFrame() {
      this.canvasContext.clearRect(0, 0, this.width, this.height);
      const frame = this.frames[this.index];
      frame.frame_RGB.map((RGB, index) => {
        const x = 5 + (index % 40) * 40;
        const y = 5 + Math.floor(index / 40) * 40;
        this.drawRoundedRect(RGB, x, y, 35, 35, 9);
      });
    },
    drawRoundedRect(fillStyle, x, y, width, height, radius) {
      this.canvasContext.beginPath();
      this.canvasContext.moveTo(x + radius, y);
      this.canvasContext.arcTo(x + width, y, x + width, y + height, radius);
      this.canvasContext.arcTo(x + width, y + height, x, y + height, radius);
      this.canvasContext.arcTo(x, y + height, x, y, radius);
      this.canvasContext.arcTo(x, y, x + radius, y, radius);
      this.canvasContext.fillStyle = fillStyle;
      this.canvasContext.fill();
    },
  },
  watch: {
    frames() {
      this.play();
    },
  },
  mounted() {
    const canvas = this.$refs.canvas;
    this.canvasContext = canvas.getContext("2d");
    this.play();
  },
  beforeDestroy() {
    clearTimeout(this.timer);
  },
};
</script>
<style lang="scss" scoped>
.c-led-canvas {
  background: #2f3032;

  canvas {
    width: 100%;
    height: 100%;
  }
}
</style>
